import { interpolateCameraValue } from './camera-transitions.js';

export interface HeadingScene {
  settings: { cameraStyle: string };
  segment?: { from: { cameraStyle: string }; to: { cameraStyle: string } } | undefined;
  amount: number;
  transitions?: { cameraStyle?: { from: { cameraStyle: string }; to: { cameraStyle: string }; amount: number } } | undefined;
}

/** Chase owns heading; platform transitions retain their existing eased blend. */
export function travelHeadingWeight(scene: HeadingScene): number {
  if (scene.transitions) {
    const transition = scene.transitions.cameraStyle;
    if (!transition) return scene.settings.cameraStyle === 'chase' ? 1 : 0;
    return travelHeadingWeight({ settings: scene.settings, segment: transition, amount: transition.amount });
  }
  if (!scene.segment) return scene.settings.cameraStyle === 'chase' ? 1 : 0;
  const from = scene.segment.from.cameraStyle === 'chase' ? 1 : 0;
  const to = scene.segment.to.cameraStyle === 'chase' ? 1 : 0;
  return from + (to - from) * scene.amount;
}

export function platformRotation(authored: number | undefined, automatic: number, weight: number): number | undefined {
  if (weight <= 0) return authored;
  automatic = ((automatic % 360) + 360) % 360;
  if (weight >= 1 || authored === undefined) return automatic;
  return interpolateCameraValue(authored, automatic, weight, true);
}
